import { z } from 'zod';
/**
 * Không gian cá nhân = tổ chức cá nhân (`organization.is_personal`) — docs/plan-personal-space.md §3.1, §3.3.
 *
 * Nhà của một người chưa thuộc tổ chức thật nào: chỉ chủ vào được, tính năng hạn chế. Cửa chặn thật nằm
 * ở API (`assertNotPersonalSpace`, trần task trong `createTaskRow`); giao diện chỉ ẩn nút cho khỏi bấm vào
 * một cửa đóng.
 */
/**
 * Số việc tối đa (còn sống, cả tổ chức) trong một không gian cá nhân — APM-PSPACE-a.
 *
 * Vượt ⇒ `PERSONAL_SPACE_TASK_LIMIT` `{ limit, current }`. Đếm cả tổ chức chứ không theo dự án: tổ chức cá
 * nhân mở dự án không cần duyệt, nên trần theo dự án chỉ là trần của một lần bấm "Tạo dự án".
 */
export const PERSONAL_SPACE_MAX_TASKS = 50;
/**
 * Loại việc gieo sẵn cho mỗi không gian cá nhân — APM-PSPACE-o.
 *
 * Tạo việc thường bắt buộc có loại, và danh mục loại việc của tổ chức mới thì trống: không gieo thì chủ
 * không tạo nổi việc đầu tiên. Tên là dữ liệu (lưu vào `task_type.name`, chủ đổi được), không phải chuỗi
 * giao diện — cùng lý lẽ với `DEFAULT_ISSUE_TYPES`. Màu nằm trong `TASK_TYPE_COLORS`.
 */
export const PERSONAL_DEFAULT_TASK_TYPES = [
    { name: 'Việc', color: '#2563eb' },
    { name: 'Lỗi', color: '#dc2626' },
    { name: 'Tính năng', color: '#16a34a' },
];
/**
 * Tính năng bị chặn ở không gian cá nhân — `details.feature` của lỗi `PERSONAL_SPACE_RESTRICTED`, để câu
 * báo nói **cái gì** bị chặn thay vì "không có quyền".
 */
export const PersonalSpaceFeature = z.enum([
    'invite',
    'document',
    'task_attachment',
    'coordination',
    'change_request',
    'design',
    /** Gộp / tách tổ chức — không gian cá nhân không là bên của đề xuất nào, như tổ chức demo. */
    'org_restructure',
]);
//# sourceMappingURL=personal-space.js.map